<template>
    <div>
        <div class="me-header"></div>
<!--        <div class="text-center" style="margin-top:-30px;">-->
<!--            <img src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fb-ssl.duitang.com%2Fuploads%2Fitem%2F201609%2F01%2F20160901172942_XHjEs.thumb.700_0.jpeg&refer=http%3A%2F%2Fb-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1616909119&t=4eefda0107069b7760df20cb336eafb2" class="avatar"/>-->
<!--        </div>-->
        <van-form  ref="formData" class="margin-top-70" @submit="onSubmit">
            <van-field
                v-model="formData.name"
                placeholder="姓名"
                left-icon="contact"
                :rules="[{ required: true, message: '请填写姓名' }]"
            />
            <van-field
                v-if="!rss2"
                v-model="formData.email"
                placeholder="请输入邮箱"
                left-icon="free-postage"
                :rules="[{ required: true, message: '请填写邮箱' }]"
            />
            <van-field
                v-model="formData.company"
                placeholder="公司名称，登录账号为手机号"
                left-icon="hotel-o"
                :rules="[{ required: true, message: '请填写公司名称' }]"
            />
            <van-field
                v-if="!rss2"
                v-model="formData.job"
                placeholder="请输入职位"
                left-icon="manager-o"
                :rules="[{ required: true, message: '请填写职位' }]"
            />
            <van-field
                v-model="formData.mobile"
                placeholder="请输入手机号，登录账号为手机号"
                left-icon="phone-o"
                type="tel"
                :rules="[{ required: true, message: '请填写手机号，登录账号为手机号' }]"
            />
<!--            <van-field-->
<!--                v-model="formData.mobile"-->
<!--                placeholder="请输入手机号"-->
<!--                left-icon="phone-o"-->
<!--                :rules="[{ required: true, message: '请填写手机号' }]"-->
<!--            />-->
            <van-field
                v-model="formData.password"
                type="password"
                placeholder="请输入密码"
                left-icon="bag-o"
                :rules="[{ required: true, message: '请填写密码' }]"
            />
            <van-field
                v-model="formData.rePassword"
                type="password"
                placeholder="请确认密码"
                left-icon="bag-o"
                :rules="[{ required: true, message: '请填写密码' }]"
            />
            <van-field
              v-model="formData.code"
              center
              clearable
              left-icon="validate"
              placeholder="请输入验证码"
              type="number"
              :rules="[{ required: true, message: '请输入验证码' }]"
            >
              <template #button>
                <van-button native-type="button" type="info" :disabled="disSms" @click="sendCode" size="small" >{{codeText}}</van-button>
              </template>
            </van-field>
<!--            <van-field-->
<!--                v-model="formData.email"-->
<!--                placeholder="请输入email"-->
<!--                left-icon="envelop-o"-->
<!--                :rules="[{ required: true, message: '请填写邮箱' }]"-->
<!--            />-->
<!--            <van-field-->
<!--                v-model="formData.company"-->
<!--                placeholder="请输入公司名称"-->
<!--                left-icon="hotel-o"-->
<!--                :rules="[{ required: true, message: '请填写公司' }]"-->
<!--            />-->
<!--            <van-field-->
<!--                v-model="formData.job"-->
<!--                placeholder="请输入职位"-->
<!--                left-icon="idcard"-->
<!--                :rules="[{ required: true, message: '请填写职位' }]"-->
<!--            />-->
            <div style="margin:50px 50px 0 50px;">
                <van-button round block color="#144b9e" @click="submitForm">注册提交</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
export default {
    name: "register",
    data() {
        return {
            formData:{
                name: '',
                // username:'',
                mobile:'',
                password: '',
                rePassword: '',
                email:'',
                // company:'',
                job:'',
                // openid:'',
                dingyue_openid:'',
                fuwu_openid:'',
                key:'',
                company:'',
                code:"" // 验证码
            },
            rss2:'1',
            codeText:'获取验证码',
            disSms:false,
            checked:false,
            time:120,
            timeId:null,
        };
    },
    created() {
        this.$emit('bgColor','#fff');
        this.formData.dingyue_openid = this.$route.query.dingyue_openid ? this.$route.query.dingyue_openid : '';
        this.formData.fuwu_openid = this.$route.query.fuwu_openid ? this.$route.query.fuwu_openid : '';
        this.formData.key = this.$route.query.key ? this.$route.query.key : '';
        this.rss2 = this.$route.query.rss2 ? this.$route.query.rss2 : '';
    },
    methods:{
      sendCode() {
        let _this = this;
        this.$http.post({
          url: 'User/sendSms',
          data: this.formData,
          success: (res) => {
            if(res === 'ok') {
              _this.disSms = true;
              _this.startTime();
              _this.$notify({ type: 'success', message: '验证码发送成功' });
            } else {
              _this.disSms = true;
              _this.startTime();
              _this.$notify({ type: 'warning', message: '请稍后重试' });
            }
          },
          fail: (res) =>{
            _this.$notify({ type: 'warning', message: res.msg });
          }
        });
      },
      timeDown(){
        if(this.time > 0){
          this.time -= 1;
          this.codeText = this.time + 's 重新获取'
        }else{
          this.disSms = false;
          clearInterval(this.timeId);
          this.timeId = null;
          this.codeText = '获取验证码'
        }
      },
      startTime(){
        this.time = 120;
        this.timeId = setInterval(this.timeDown,1000);
      },
      submitForm(){
        this.$refs.formData.submit();
      },
      onSubmit(values) {
            let _this = this;

            this.$http.post({
                url:'User/register',
                data:this.formData,
                success(res){
                    _this.$notify({ type: 'success', message: '注册成功，已自动登录' });

                    _this.$user.setToken(res.token);
                    _this.$user.setUid(res.uid);
                    _this.$user.setMobile(res.mobile);
                    _this.$user.setUserName(res.username);
                    _this.$user.setDingyueOpenid(res.dingyue_openid);
                    _this.$user.setFuwuOpenid(res.fuwu_openid);
                    _this.$user.setAvatar(res.avatar);

                    let _lastPath = _this.$store.state.lastPath;

                    if(_lastPath){
                        _this.$router.replace({path:_lastPath,query:{..._this.$route.query}});
                    }else {
                        _this.$router.replace({path: '/',query:{..._this.$route.query}});
                    }

                    // _this.$router.replace({path:'/'});
                }
            })
        },
    }
}
</script>
<style>
  .van-icon-validate{
    width: 16px;
    height: 16px;
    background: url("../../assets/validate-code-icon.png") no-repeat;
  }
</style>
